import React, { useState } from 'react';
import * as yup from 'yup';
import { useFormik, FormikProvider, FieldArray } from 'formik';
import { useSnackbar } from 'notistack';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import {
  Box,
  Paper,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';


import { listProjectTechs } from '../../../modules/techModule/projectTechs';

import BootstrapDialog, { BootstrapDialogTitle } from '../../../components/common/dialog/BootstrapDialog';
import DetailTemplate from '../../../components/common/template/DetailTemplate';
import TechCustForm from '../../../components/techmng/support/TechCustForm';
import TechReqForm from '../../../components/techmng/support/TechReqForm';
import _ from 'lodash';
import * as techApi from '../../../lib/api/tech';
import * as fileApi from '../../../lib/api/file';
import TechMultiFileForm from '../../../components/techmng/support/TechMultiFileForm';
import TechProductListForm from '../../../components/techmng/support/TechProductListForm';
import TechAddUsersForm from '../../../components/techmng/support/TechAddUsersForm';

import Draggable from 'react-draggable';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-tech-dialog"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const TechAddModalContainer = ({ open, handleClose, project }) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [workUsers, setWorkUsers] = useState([]);
  const [ccUsers, setCcUsers] = useState([]);

  const defaultWorkTxt = `방문 시간 :\r\n요청 사항 :\r\n기타 참조자(연락처) :\r\n`;

  let initialValues = {
    custNm: project?.partnerInc,
    signStatus: '',
    custAddr: '',
    custEmpNm: project?.chargeNm ? project?.chargeNm : '',
    custTel: project?.chargeTel ? project?.chargeTel : '',
    custEml: project?.chargeEml ? project?.chargeEml : '',
    workTyp: '기술지원',
    workTypDet: '',
    workStDt: '',
    workEdDt: '',
    workTxt: defaultWorkTxt,
    workEmp: [],
    prdtList: [],
    files: [{ file: null, fileDesc: '' }]
  };

  const validationSchema = yup.object({
    custNm: yup.string().required('고객명을 입력하세요'),
    custEmpNm: yup.string().required('담당자명을 입력하세요'),
    custTel: yup.string()
      .matches(
        /^[0-9]{2,3}-[0-9]{3,4}-[0-9]{4}$/g,
        "담당자 휴대폰 번호를 확인하십시오"
      ),
    custEml: yup.string().email('담당자 이메일을 확인하세요'),
    workTyp: yup.string().required('기술지원 타입을 선택하세요.'),
    workStDt: yup
      .date()
      .required("작업 요청 시작일을 입력하세요")
      .nullable()
      .default(undefined),
    workEdDt: yup
      .date()
      .required("작업 요청 종료일을 입력하세요")
      .min(yup.ref('workStDt'), '작업 요청 종료일을 확인하세요')
      .when('workStDt', (workStDt, schema) => {
        if (workStDt)
          return schema.required('작업 요청 종료일을 입력하세요');
      })
      .nullable()
      .default(undefined),
    workTxt: yup.string().required('작업 요청 사항을 입력하세요'),
    prdtList: yup.array().of(
      yup.object().shape({
        productUuid: yup.string().nullable(),
        productCnt: yup.number('수량은 숫자만 가능합니다')
          .min(1, '제품 수량을 확인하세요')
          .when('productUuid', (productUuid, schema) => {
            if (productUuid)
              return schema.required('제품수량을 입력하세요');
          })
      })
    ),
    // files: yup.array().of(
    //   yup.object().shape({
    //     file: yup.mixed().required('파일을 선택하세요'),
    //     fileDesc: yup.string().nullable('비고를 입력하세요'),
    //   })
    // )
  });



  const addUsers = (type, newUser) => {
    const usrs = (type === 'cc') ? [...ccUsers, ...newUser] : [...workUsers, ...newUser];
    const filteredUsrs = _.uniqBy(usrs, 'usrUuid');
    (type === 'cc') ? setCcUsers(filteredUsrs) : setWorkUsers(filteredUsrs);
  }

  const removeUser = (type, user) => {
    const usrs = (type === 'cc') ? ccUsers : workUsers
    const filteredUsers = _.filter(usrs, (usr) => usr.usrUuid !== user.usrUuid);
    (type === 'cc') ? setCcUsers(filteredUsers) : setWorkUsers(filteredUsers);
  }

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {

      setSubmitting(true);


      //console.log(JSON.stringify(dataToSubmit,2), 'values');
      onSaves(values);
      setSubmitting(false);
    },
  });

  const onFileSave = async (value, techReq) => {
    let formData = new FormData();
    formData.append('fileDt', value.file);
    formData.append('fileTyp', 'tech');
    formData.append('fileAttrVal1', techReq.reqUuid);
    formData.append('fileAttrVal2', techReq.prjUuiid);
    formData.append('fileAttrVal3', "기술 지원 요청");
    formData.append('fileDesc', value.fileDesc);


    try {
      const response = await fileApi.addFiles(formData);

      if (response.data.result === 'success') {
        enqueueSnackbar("파일 업로드 성공", {
          variant: 'success',
        });
      }

    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const setDataToSubmit = (values) => {
    let dataToSubmit = {
      prjUuid: project.prjUuid,
      custNm: values.custNm,
      signStatus: values.signStatus,
      custAddr: values.custAddr,
      custEmpNm: values.custEmpNm,
      custTel: values.custTel,
      custEml: values.custEml,
      workTyp: values.workTyp,
      workTypDet: values.workTypDet,
      workStDt: (values.workStDt) ? dayjs(values.workStDt).format('YYYY-MM-DD') : null,
      workEdDt: (values.workEdDt) ? dayjs(values.workEdDt).format('YYYY-MM-DD') : null,
      workTxt: values.workTxt,
      refList: ccUsers,
      prdtList: values.prdtList,
      reqStatus: '지원대기',
      reqGrade: 1,
    };
    return dataToSubmit;
  }

  const onSaves = async (values) => {
    const data = [];
    if (workUsers.length > 0) {
      workUsers.forEach(work => {
        let dataToSubmit = setDataToSubmit(values);
        dataToSubmit.workEmp = work.usrUuid;
        data.push(dataToSubmit);
      })
    } else {
      let dataToSubmit = setDataToSubmit(values);
      data.push(dataToSubmit);
    }

    try {
      data.forEach(item => {
        onSave(item, values.files);
      });

      enqueueSnackbar("기술 지원 요청 작성 성공", {
        variant: 'success',
      });
      onClose();

    } catch (err) {
      let message =
        err.response !== 'undefined' ? err.response.data?.message : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }

  }



  //workEmp
  const onSave = async (dataToSubmit, files) => {

    try {

      const res = await techApi.addTechReq(dataToSubmit);
      if (res.data.info) {
        if (files.length > 0 && files[0].file !== null) {
          files.forEach(value => {
            onFileSave(value, res.data.info);
          })
        }
        dispatch(listProjectTechs(project.prjUuid));
      }

    } catch (err) {
      let message =
        err.response !== 'undefined' ? err.response.data?.message : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const onClose = () => {
    formik.resetForm();
    setWorkUsers([]);
    setCcUsers([]);
    handleClose();
  };

  return (
    <BootstrapDialog
      open={open}
      onClose={onClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-tech-dialog"
      fullWidth={true}
      maxWidth="md"
    >
      <BootstrapDialogTitle style={{ cursor: 'move' }} id="draggable-tech-dialog" onClose={onClose}>
        지원 요청
      </BootstrapDialogTitle>
      <form noValidate autoComplete="off" onSubmit={formik.handleSubmit}>
        <DialogContent
          dividers
          sx={{
            height: 400,
            overflowY: 'auto',
          }}
        >
          <DetailTemplate title="고객 정보">
            <TechCustForm formik={formik} />
          </DetailTemplate>

          <DetailTemplate title="기술 지원 요청 내역">
            <TechReqForm formik={formik} />
          </DetailTemplate>
          <DetailTemplate title="작업자">
            <TechAddUsersForm formik={formik} ccUsers={ccUsers} workUsers={workUsers} addUsers={addUsers} removeUser={removeUser} />
          </DetailTemplate>
          <DetailTemplate title="공급 제품 정보">
            <FormikProvider value={formik}>
              <TechProductListForm formik={formik} />
            </FormikProvider>
          </DetailTemplate>
          <DetailTemplate title="첨부 서류">
            <FormikProvider value={formik}>
              <FieldArray name="files"
                render={arrayHelpers => (
                  <Box>
                    <Box>
                      {formik.values?.files.map((f, index) => {
                        return (
                          <TechMultiFileForm
                            key={index}
                            file={f}
                            index={index}
                            touched={formik.touched}
                            errors={formik.errors}
                            handleChange={formik.handleChange}
                            handleBlur={formik.handleBlur}
                            handleRemove={() => arrayHelpers.remove(index)} />
                        )
                      })}
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', my: 2 }}>
                      <Button sx={{ mx: 2 }} color="secondary" variant="outlined" onClick={() => arrayHelpers.push({ fileDesc: '', file: null })}>파일 추가</Button>
                    </Box>
                  </Box>

                )}

              >

              </FieldArray>
            </FormikProvider>

          </DetailTemplate>
        </DialogContent>
        <DialogActions>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              m: 1,
            }}
          >
            <Button
              type="submit"
              color="primary"
              variant="contained"
              disabled={formik.isSubmitting}
            >
              저장
            </Button>
          </Box>
        </DialogActions>
      </form>
    </BootstrapDialog>
  );
};

export default TechAddModalContainer;
